import './breadcrumb.css';
export default {
  "breadcrumb": "pf-v6-c-breadcrumb",
  "breadcrumbDropdown": "pf-v6-c-breadcrumb__dropdown",
  "breadcrumbHeading": "pf-v6-c-breadcrumb__heading",
  "breadcrumbItem": "pf-v6-c-breadcrumb__item",
  "breadcrumbItemDivider": "pf-v6-c-breadcrumb__item-divider",
  "breadcrumbLink": "pf-v6-c-breadcrumb__link",
  "breadcrumbList": "pf-v6-c-breadcrumb__list",
  "dirRtl": "pf-v6-m-dir-rtl",
  "modifiers": {
    "current": "pf-m-current"
  }
};